<template>
  <div>
    <v-card color="basil">
      <v-card-title class="text-center justify-center py-3">
        <h1 class="font-weight-bold text-h6 basil--text">About Event</h1>
      </v-card-title>

      <v-tabs v-model="tab" background-color="transparent" grow>
        <v-tab> Rundown </v-tab>
        <!-- <v-tab> Panitia </v-tab> -->
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card color="basil" flat>
            <v-card-text>
              <div class="wrapperProgress">
                <ul class="StepProgress" v-for="(run, i) in items" :key="i">
                  <li
                    class="StepProgress-item"
                    :class="run.isactive ? 'is-done' : ''"
                  >
                    <strong>{{ run.startTime }}</strong
                    >{{ run.title }}
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- <v-tab-item>
          <v-card color="basil" flat>
            <v-card-text><Panitia /></v-card-text>
          </v-card>
        </v-tab-item> -->
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Panitia from "../../components/Panitia.vue";
export default {
  components: {
    Panitia,
  },
  data() {
    return {
      tab: null,
      items: [],
    };
  },
  beforeMount() {
    this.fetchRundowns();
  },
  methods: {
    fetchRundowns() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/rundowns`)
        .then((response) => {
          const payload = response.data;
          this.items = payload.data;
        })
        .catch((error) => {
          if (error.response) {
            const payload = error.response.data;
            this.pesan = payload.message;
            this.alert = true;
          } else {
            const payload = error.message;
            this.pesan = payload;
            this.alert = true;
          }
        });
    },
  },
};
</script>
<style scoped>
/* Helper classes */
.basil {
  /* background-color: #FFFBE6 !important; */
  height: 70vh;
}
.basil--text {
  color: #356859 !important;
}
</style>

<style lang="scss" scoped>
.wrapperProgress {
  width: 100%;
  font-family: "Helvetica";
  font-size: 14px;
  height: 60vh;
  overflow: scroll;
}

.StepProgress {
  position: relative;
  padding-left: 45px;
  list-style: none;
  text-align: left;

  &::before {
    display: inline-block;
    content: "";
    position: absolute;
    top: 0;
    left: 15px;
    width: 10px;
    height: 100%;
    border-left: 2px solid #ccc;
  }

  &-item {
    position: relative;
    counter-increment: list;
    padding-bottom: 10px;

    &::before {
      display: inline-block;
      content: "";
      position: absolute;
      left: -30px;
      height: 100%;
      width: 10px;
    }

    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      top: 0;
      left: -37px;
      width: 15px;
      height: 15px;
      border: 2px solid #ccc;
      border-radius: 50%;
      background-color: #fff;
    }

    &.is-done {
      &::before {
        border-left: 2px solid rgb(240, 237, 237);
      }
      &::after {
        font-size: 10px;
        color: #fff;
        text-align: center;
        border: 2px solid rgb(123, 53, 235);
        background-color: rgb(123, 53, 235);
      }
    }
  }

  strong {
    display: block;
    margin: 0px !important;
    line-height: 10px;
    padding-top: 3px !important;
    font-size: 12px;
  }
}
</style>
